import { render } from "./FavoritesList.vue?vue&type=template&id=7f2dba08&scoped=true"
import script from "./FavoritesList.vue?vue&type=script&lang=js"
export * from "./FavoritesList.vue?vue&type=script&lang=js"

import "./FavoritesList.vue?vue&type=style&index=0&id=7f2dba08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2dba08"]])

export default __exports__